import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const Preferences = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-4">Preferences</h2>
        
        <Card>
          <CardHeader>
            <CardTitle>Coming Soon</CardTitle>
            <CardDescription>
              Preference settings will be available here soon
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              This section will include theme preferences, notification settings, and other customization options.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Preferences;
